"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpIdleTimeOutModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var react_i18next_1 = require("react-i18next");
var idleTimeOut_constants_1 = require("../../../../api/constants/idleTimeOut.constants");
var DpModal_1 = require("../../Modal/DpModal");
var DpLoadingWrapper_1 = require("../../LoadingWrapper/DpLoadingWrapper");
var DpIdleTimeOutModal = function (_a) {
    var show = _a.show, closeHandler = _a.closeHandler, submitHandler = _a.submitHandler;
    // ---------------------------- State
    var _b = (0, react_1.useState)(idleTimeOut_constants_1.MODAL_MINUTES_TIMEOUT), minutes = _b[0], setMinutes = _b[1];
    var _c = (0, react_1.useState)(idleTimeOut_constants_1.MODAL_SECONDS_TIMEOUT), seconds = _c[0], setSeconds = _c[1];
    // ---------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // ------------------------------- Methods
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            else if (minutes === 0) {
                submitHandler();
                clearInterval(interval);
            }
            else {
                setMinutes(minutes - 1);
                setSeconds(59);
            }
        }, 1000);
        // clear interval on re-render to avoid memory leaks
        return function () { return clearInterval(interval); };
    });
    return ((0, jsx_runtime_1.jsxs)(DpModal_1.DpModal, { show: show, onHide: closeHandler, size: "md", dialogClassName: "text-primary", "aria-labelledby": "time-out-modal-title", children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Title, { id: "time-out-modal-title", children: t('DpIdleTimeOutModal.title') }) }), (0, jsx_runtime_1.jsxs)(DpModal_1.DpModal.Body, { children: [t('DpIdleTimeOutModal.content'), (0, jsx_runtime_1.jsxs)("span", { className: "timer h3", children: [' ', "0", minutes, ":", seconds < 10 ? "0".concat(seconds) : seconds] })] }), (0, jsx_runtime_1.jsxs)(DpModal_1.DpModal.Footer, { children: [(0, jsx_runtime_1.jsx)(DpLoadingWrapper_1.DpLoadingWrapper, { as: react_bootstrap_1.Button, onClick: submitHandler, variant: "outline-primary", className: "submit-button", children: t('DpIdleTimeOutModal.logOutButton') }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { onClick: closeHandler, className: "cancel-button", children: t('DpIdleTimeOutModal.extendButton') })] })] }));
};
exports.DpIdleTimeOutModal = DpIdleTimeOutModal;
exports.default = exports.DpIdleTimeOutModal;
